import { render } from "./QuickProjectCreation.vue?vue&type=template&id=db7581e0&lang=pug"
import script from "./QuickProjectCreation.vue?vue&type=script&lang=js"
export * from "./QuickProjectCreation.vue?vue&type=script&lang=js"

import "./QuickProjectCreation.vue?vue&type=style&index=0&id=db7581e0&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__